import React, { Component } from 'react'
import GroupGridFilterCustomerItem from "./GroupGridFilterCustomerItem";

export default class GroupGridFilterCustomerContainer extends Component {

    render() {
        let items = [];
        this.props.items.forEach((item, index) => {
            items.push(<GroupGridFilterCustomerItem key={index} groupName={item} onFilter={this.props.onFilter}/>);
        });
        return (
            <div style={{display: 'flex', flexDirection: 'column', marginTop: 5, position: 'absolute', height: window.$(window).innerHeight() - 55,
                width: 160, overflowY: 'auto', backgroundColor: '#bbb'}}>
                <GroupGridFilterCustomerItem groupName={'Все'} onFilter={this.props.clearFilter}/>
                {items}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/GroupGridFilterCustomerContainer.js